export function getQuery(url: string): Record<string, string>
export function getQuery(url: string, name: string): string
export function getQuery(url: string, name?: string): Record<string, string> | string {
  const queryString = url.split('?')[1] || ''
  if (!queryString) {
    return {}
  }
  const query = queryString.split('&')
  const queryObject = Object.fromEntries(
    query.map(item => {
      const [key, value] = item.split('=')
      return [decodeURIComponent(key), decodeURIComponent(value)]
    })
  )
  if (name) {
    return queryObject[name]
  }
  return queryObject
}
